import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    Box,
    IconButton,
    DialogContent,
    Grid,
    Button,
    Stack,
    Alert,
    TextField,
    DialogActions,
    InputAdornment

} from '@mui/material';
// import required css from library
import "react-datepicker/dist/react-datepicker.css";
import PropTypes from 'prop-types';
import { Close } from '@mui/icons-material';
import { CustomizedSnackbar } from '../../../../../shared/index';
import { axiosFetch } from "../../../../../utils/AxiosFetch";
import { Link, useNavigate, useParams } from 'react-router-dom'
import dummyData from '../../SearchKeyResultsDummyData.json';
import { StencilList } from "react-placemoulder";
import InfiniteScroll from "react-infinite-scroller";
import SearchObjectiveList from "./SearchObjectiveList";
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch } from "react-redux";
import { SnackbarActions } from "../../../../../redux/actions/snackbar.actions";
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));


const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    ValidatorForm.addValidationRule("minLength", (value) => {
        if (value.length > 2) {
            return true;
        }
        return false;
    })
    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const SearchObjectivePopup = (props) => {


    let selectedObjIds = [];

    ValidatorForm.addValidationRule('isValid', (value) => {
        var titleRegx = "^[A-Za-z_ |-][A-Za-z0-9_@./#&+() |-]*$"

        if (value.match(titleRegx)) {
            return true;
        }
        return false;

    })


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const [open, setOpen] = useState(props && props.open);
    const [keyword, setKeyword] = useState("");
    const [isSelected, setIsSelected] = useState(false);
    const [keyResultList, setKeyResultList] = useState(dummyData);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [scrolling, setScrolling] = useState(false);
    const [totalRecords, setTotalRecords] = React.useState("");
    const [totalPages, setTotalPages] = React.useState("");
    const [resultsPerPage, setResultsPerPage] = React.useState(100);
    const [showContent, setShowContent] = useState(false);
    const [keyWordErrMsg, setKeywordErrMsg] = useState(false);
    const [isSubmit, setIsSubmit] = useState(true);



    const handleSubmit = () => {
        if (keyword === "") {
            setKeywordErrMsg(true);
            return false;
        }
        if (keyword !== "") {
            // setIsLoading(true);
            axiosFetch({
                method: "post",
                url: "/okrs/searchkr",
                requestConfig: {
                    "IsObjective": true,
                    "ObjectiveId": id,
                    keyword,
                    page,
                    resultsPerPage
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        setIsSubmit(false);
                        setShowContent(true);
                        // setIsLoading(false);
                        if (page > 1) {
                            var keyResults = [...keyResultList.krResult, ...res.data.krResult];
                            setKeyResultList({ krResult: keyResults });
                            setScrolling(false);
                        }
                        else {
                            setKeyResultList(res.data);
                        }
                        setTotalPages(res.data.totalPages);
                        setTotalRecords(res.data.totalRecords);
                    }
                    else if (res.status === 400) {
                        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                    }
                    else if (res.status === 401) {
                        navigate('/');
                    }

                })
                .catch(err => console.error(err));
        }
    }

    const handleChange = (event, id) => {
        if (event) {
            selectedObjIds.push(id);
        }
        else {
            const result = selectedObjIds.findIndex(selectedId => selectedId === id).splice;
            selectedObjIds.splice(result, 1);
        }
        if (selectedObjIds.length === 0) {
            setIsSubmit(true);
        }
        else if (selectedObjIds.length > 0) {
            setIsSubmit(false);
        }

    }
    const handleSelect = (selectedItem) => {
        setIsSelected(!isSelected);
        props.handleChangeChosenKR({
            id: selectedItem.id,
            title: selectedItem.title
        });
        props.toggleSearchObjPopup(false);

    }

    const handleInfiniteOnLoad = () => {
        if (page + 1 <= totalPages) {
            setPage(page + 1);
        }
        setScrolling(true);
    }

    const handleClear = () => {
        setShowContent(false);
        setKeyword("");
        setIsSubmit(true);
    }

    const handleChangeKeyword = (e) => {
        setKeyword(e.target.value);
        setKeywordErrMsg(false);
    }

    const handleClick = () => {

        if (selectedObjIds.length !== 0) {
            axiosFetch({
                method: "post",
                url: "/OKRs/assign",
                requestConfig: {
                    "OkrIds": selectedObjIds.toString(),
                    "assignmentTypeId": 2,
                    "objectiveId": id
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        if (res.data === "success") {
                            dispatch(SnackbarActions(true, "success", "Key Results Added!"))
                            props.toggleSearchObjPopup(false);
                            props.loadKeyResults();
                        }
                    }
                    else if (res.status === 400) {
                        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                    }
                })

                .catch(err => console.error(err));
        }
    }

    return (
        <div id="scrollableDiv">
            {
                isLoading ? (
                    <StencilList
                        length={1}
                        Component={SearchObjectiveList}
                        data={dummyData}
                    />
                ) : (<InfiniteScroll
                    dataLength={keyResultList.krResult.length}
                    initialLoad={false}
                    loadMore={() => handleInfiniteOnLoad()}
                    hasMore={true}
                    scrollThreshold={10}
                    scrollabletarget="scrollableDiv"
                    useWindow={false}
                >
                    <ValidatorForm onSubmit={handleSubmit}>

                        <BootstrapDialog
                            aria-labelledby="customized-dialog-title"
                            open={open}
                            fullWidth="sm"
                            maxWidth="sm"
                            onClose={() => props.toggleSearchObjPopup(false)}
                        >


                            <BootstrapDialogTitle
                                id="customized-dialog-title"
                                onClose={() => props.toggleSearchObjPopup(false)}
                                className="modal-heading"
                            >
                                Create Key result from existing objective
                            </BootstrapDialogTitle>

                            <DialogContent dividers>
                                <Stack sx={{ width: '100%', marginBottom: "15px" }} >
                                    <Alert severity="warning">Key Results are measurable outcomes, which means they should have a number in them. With Key Results you define what the success of your Objective looks like. Do not list tasks or projects, those are outputs and not measurable outcomes! Instead think about WHY you are doing things and what kind of results you want.</Alert></Stack>                                
                                <Box
                                    alignItems="center"
                                    display="flex"
                                    justifyContent="center"
                                    component="form"
                                    autoComplete="off"
                                >

                                    <Grid container item spacing={2} xs={12} className="grid-margins">
                                        <Grid item xs={12} className="grid-margins">
                                            <TextValidator
                                                id="input-with-icon-textfield"
                                                variant="outlined"
                                                fullWidth
                                                label="Search Objective"
                                                value={keyword}
                                                onChange={handleChangeKeyword}
                                                validators={["minLength"]}
                                                errorMessages={["Please fill out this field with minimum 3 characters"]}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton style={{ cursor: "pointer" }} type="submit">
                                                                <SearchIcon />
                                                                {/* <SearchIcon onClick={handleSubmit} style={{ cursor: "pointer" }} /> */}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            {/* <span className="error-message">{keyWordErrMsg ? "Please fill out this field" : ""}</span> */}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Link to="" className="clear-all-link" onClick={handleClear}>Clear</Link>
                                        </Grid>
                                        {showContent ? <Grid item xs={12} className="grid-margins">
                                            <SearchObjectiveList
                                                {...keyResultList}
                                                handleChangeChosenKR={handleSelect}
                                                toggleSearchObjPopup={props.toggleSearchObjPopup}
                                                handleChange={handleChange}
                                            />
                                        </Grid> : ""}
                                    </Grid>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button variant="contained" className="theme-btn" disabled={isSubmit} onClick={handleClick}>Submit</Button>
                            </DialogActions>

                        </BootstrapDialog>
                    </ValidatorForm>
                    <CustomizedSnackbar />

                </InfiniteScroll >)
            }
        </div >
    );
};




export default SearchObjectivePopup;
